module.exports = __webpack_public_path__ + "static/img/COC2023-28.789aaed.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-28.png
// module id = KDmW
// module chunks = 0